import { render, staticRenderFns } from "./BooleanFieldHeader.vue?vue&type=template&id=474d1fdd&"
import script from "./BooleanFieldHeader.vue?vue&type=script&lang=ts&"
export * from "./BooleanFieldHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports